import { r4Client, r4Error } from "@/services";

const AuthenticatedDomainsApi = {
  async fetchAuthenticatedSenders() {
    try {
      const resp = await r4Client().get("/api/v1/authenticated_senders");
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },

  async revalidateAuthenticatedSender(authenticatedSender) {
    try {
      const resp = await r4Client().put(
        `/api/v1/authenticated_senders/${authenticatedSender.id}`,
        { domain: authenticatedSender.domain }
      );
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async revalidateAllAuthenticatedSenders() {
    try {
      const resp = await r4Client().post(
        "/api/v1/authenticated_senders/reauthenticate"
      );
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async fetchAuthenticatedLinks() {
    try {
      const resp = await r4Client().get("/api/v1/authenticated_links");
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async revalidateAuthenticatedLink(authenticatedLink) {
    try {
      const resp = await r4Client().put(
        `/api/v1/authenticated_links/${authenticatedLink.id}`,
        { domain: authenticatedLink.domain }
      );
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async revalidateAllAuthenticatedLinks() {
    try {
      const resp = await r4Client().post(
        "/api/v1/authenticated_links/reauthenticate"
      );
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
};

export default AuthenticatedDomainsApi;
